'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOUND_MODE = exports.CHROME_MODE = exports.INVERTED_MODE = exports.SMOOTHING_MODE = exports.STRIKE_MODE = exports.BOLD_MODE = exports.FONT_MODE = exports.JUSTIFICATION_MODE = exports.UNDERSCORE_MODE = exports.PRINT_MODE = undefined;
exports.horizontalTab = horizontalTab;
exports.lineFeed = lineFeed;
exports.setCharacterSpacing = setCharacterSpacing;
exports.setPrintMode = setPrintMode;
exports.setPrintPositionAbs = setPrintPositionAbs;
exports.selectCharacterSet = selectCharacterSet;
exports.setUnderscoreMode = setUnderscoreMode;
exports.resetLineSpacing = resetLineSpacing;
exports.setLineSpacing = setLineSpacing;
exports.initialisePrinter = initialisePrinter;
exports.setTabstops = setTabstops;
exports.clearTabstops = clearTabstops;
exports.setJustification = setJustification;
exports.setFontMode = setFontMode;
exports.setBoldMode = setBoldMode;
exports.setStrikeMode = setStrikeMode;
exports.setFontSize = setFontSize;
exports.text = text;
exports.printAndFeedLines = printAndFeedLines;
exports.setSmoothingMode = setSmoothingMode;
exports.setInvertedMode = setInvertedMode;
exports.setCharacterCodePage = setCharacterCodePage;
exports.resetCharacterCodePage = resetCharacterCodePage;
exports.setGraphicsDataMonochrome = setGraphicsDataMonochrome;
exports.printGraphics = printGraphics;
exports.soundBuzzer = soundBuzzer;

var _constants = require('./constants');

var _utils = require('./utils');

/**
 * returns a tab character
 * @return {ArrayBuffer}
 */
function horizontalTab() {
  var commandBuffer = new ArrayBuffer(1);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv[0] = _constants.HT;
  return commandBuffer;
}

/**
 * returns a newline character
 * @return {ArrayBuffer}
 */
function lineFeed() {
  var commandBuffer = new ArrayBuffer(1);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv[0] = _constants.LF;
  return commandBuffer;
}

/**
 * Helper function to simplify the process of creating a buffer, setting
 * a command prefix, command and a PC437 number
 * @param {Number} commandPrefix
 * @param {Number} command
 * @param {Number} param
 * @return {ArrayBuffer}
 */
function singleNumericalParamCommand(commandPrefix, command, param) {
  var commandBuffer = new ArrayBuffer(3);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv.set([commandPrefix, command, param]);
  return commandBuffer;
}

/**
 * Helper function to simplify the process of creating a buffer, setting
 * a command prefix and command
 * @param {Number} commandPrefix
 * @param {Number} command
 * @return {ArrayBuffer}
 */
function noParamCommand(commandPrefix, command) {
  var commandBuffer = new ArrayBuffer(2);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv.set([commandPrefix, command]);
  return commandBuffer;
}

/**
 * @param {number} spacing 0-255
 * @return {string}
 */
function setCharacterSpacing(spacing) {
  return singleNumericalParamCommand(_constants.ESC, _constants.SP, spacing);
}

var PRINT_MODE = exports.PRINT_MODE = {
  FONT_1: 0 << 0,
  FONT_2: 1 << 0,
  BOLD_ON: 1 << 3,
  DOUBLE_HEIGHT_ON: 1 << 4,
  DOUBLE_WIDTH_ON: 1 << 5,
  UNDERLINE_ON: 1 << 7,
  BOLD_OFF: 0 << 3,
  DOUBLE_HEIGHT_OFF: 0 << 4,
  DOUBLE_WIDTH_OFF: 0 << 5,
  UNDERLINE_OFF: 0 << 7
};

var UNDERSCORE_MODE = exports.UNDERSCORE_MODE = {
  UNDERSCORE_OFF: 0,
  UNDERSCORE_SINGLE: 1,
  UNDERSCORE_DOUBLE: 2
};

var JUSTIFICATION_MODE = exports.JUSTIFICATION_MODE = {
  JUSTIFICATION_LEFT: 0,
  JUSTIFICATION_CENTER: 1,
  JUSTIFICATION_RIGHT: 2
};

var FONT_MODE = exports.FONT_MODE = {
  FONT_A: 0,
  FONT_B: 1
};

var BOLD_MODE = exports.BOLD_MODE = {
  BOLD_ON: 1,
  BOLD_OFF: 0
};

var STRIKE_MODE = exports.STRIKE_MODE = {
  STRIKE_SINGLE: 0,
  STRIKE_DOUBLE: 1
};

var SMOOTHING_MODE = exports.SMOOTHING_MODE = {
  SMOOTHING_OFF: 0,
  SMOOTHING_ON: 1
};

var INVERTED_MODE = exports.INVERTED_MODE = {
  INVERTED_OFF: 0,
  INVERTED_ON: 1
};

var CHROME_MODE = exports.CHROME_MODE = {
  CHROME_MONO: (0, _utils.toPC437)('0'),
  CHROME_MULTITONE: (0, _utils.toPC437)('4')
};

var SOUND_MODE = exports.SOUND_MODE = {
  SOUND_OFF: (0, _utils.toPC437)('0'),
  SOUND_1320HZ_1000MS: (0, _utils.toPC437)('1'),
  SOUND_2490HZ_1000MS: (0, _utils.toPC437)('2'),
  SOUND_1320HZ_200MS: (0, _utils.toPC437)('3'),
  SOUND_2490HZ_200MS: (0, _utils.toPC437)('4'),
  SOUND_1320HZ_200MS_ON_OFF_X2: (0, _utils.toPC437)('5'),
  SOUND_2490HZ_200MS_ON_OFF_X2: (0, _utils.toPC437)('6'),
  SOUND_1320HZ_500MS: (0, _utils.toPC437)('7'),
  SOUND_2490HZ_500MS: (0, _utils.toPC437)('8'),
  SOUND_1320HZ_200MS_ON_OFF_X3: (0, _utils.toPC437)('9'),
  SOUND_2490HZ_200MS_ON_OFF_X3: (0, _utils.toPC437)(':')

};

/**
 * Sets multiple print mode settings with a single command
 * @param {PRINT_MODE} mode
 * @return {ArrayBuffer}
 */
function setPrintMode(mode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('!'), mode);
}

/**
 *
 * @param {number }xOffset 0-65535
 * @param {number} yOffset 0-65535
 * @return {string}
 */
function setPrintPositionAbs(xOffset) {
  var yOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var commandBuffer = new ArrayBuffer(4);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv.set([_constants.ESC, (0, _utils.toPC437)('$'), yOffset, xOffset]);
  return commandBuffer;
}

/**
 * Sets the printer to printer characters from a user defined character set, or
 * the inbuilt character set.
 * @param {number} characterSet when the least significant bit is set to 0,
 * the inbuilt set will be used, when set to 1, the user defined set will be
 * used.
 * @return {string}
 */
function selectCharacterSet(characterSet) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('%'), characterSet);
}

/**
 *
 * @param {UNDERSCORE_MODE} underscoreMode
 * @return {string}
 */
function setUnderscoreMode(underscoreMode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('-'), underscoreMode);
}

/**
 * Resets the line spacing for the proceeding lines
 * @return {ArrayBuffer}
 */
function resetLineSpacing() {
  return noParamCommand(_constants.ESC, (0, _utils.toPC437)('2'));
}

/**
 *
 * @param {number} spacing 0-255
 * @return {ArrayBuffer}
 */
function setLineSpacing(spacing) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('3'), spacing);
}

/**
 * Clears the data in the print buffer and resets the printer modes.
 * @return {ArrayBuffer}
 */
function initialisePrinter() {
  return noParamCommand(_constants.ESC, (0, _utils.toPC437)('@'));
}

/**
 *
 * @param {number[]} tabStops 1-255, maximum of 32 stops
 * @return {ArrayBuffer}
 */
function setTabstops(tabStops) {
  var commandBuffer = new ArrayBuffer(3 + tabStops.length);
  var dv = new Uint8ClampedArray(commandBuffer);
  dv.set([_constants.ESC, (0, _utils.toPC437)('D')]);
  var i = 2;
  dv.set(tabStops, i);
  i += tabStops.length;
  dv[i] = _constants.NUL;
  return commandBuffer;
}

/**
 *
 * @return {ArrayBuffer}
 */
function clearTabstops() {
  return setTabstops([]);
}

/**
 *
 * @param {JUSTIFICATION_MODE} justificationMode
 * @return {ArrayBuffer}
 */
function setJustification(justificationMode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('a'), justificationMode);
}

/**
 *
 * @param {FONT_MODE} fontMode
 * @return {ArrayBuffer}
 */
function setFontMode(fontMode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('M'), fontMode);
}

/**
 *
 * @param {BOLD_MODE} boldMode
 * @return {ArrayBuffer}
 */
function setBoldMode(boldMode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('E'), boldMode);
}

/**
 * Strike refers to the print quality. When strikeMode is set to STRIKE_DOUBLE,
 * each point is plotted on the page twice with a slight offset to improve
 * the aliasing.
 * @param {STRIKE_MODE} strikeMode
 * @return {string}
 */
function setStrikeMode(strikeMode) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('G'), strikeMode);
}

/**
 *
 * @param {Number} heightScale 1-8
 * @param {Number} widthScale 1-8
 * @return {ArrayBuffer}
 */
function setFontSize(heightScale, widthScale) {
  // the expected range is between 0 and 7, so remove 1 from the source scalar
  // also clamp the values just in case someone didn't read the documentation
  var fontWidth = widthScale - 1 & 0x07;
  var fontHeight = heightScale - 1 & 0x07;
  // bitpack the two (shifted) values into the same byte
  var fontSize = fontWidth << 4 | fontHeight;
  return singleNumericalParamCommand(_constants.GS, (0, _utils.toPC437)('!'), fontSize);
}

/**
 *
 * @param {String} text
 * @return {ArrayBuffer}
 */
function text(text) {
  var commandBuffer = new ArrayBuffer(text.length);
  var dv = new Uint8ClampedArray(commandBuffer);
  var utf8Text = [];
  for (var i = 0; i < text.length; i++) {
    utf8Text.push(text.charCodeAt(i));
  }
  dv.set(utf8Text);
  return commandBuffer;
}

/**
 *
 * @param {Number} lineCount the number of lines to feed after printing the
 * current line buffer contents
 * @return {ArrayBuffer}
 */
function printAndFeedLines(lineCount) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('d'), lineCount);
}

/**
 *
 * @param {SMOOTHING_MODE} smoothingMode
 * @return {ArrayBuffer}
 */
function setSmoothingMode(smoothingMode) {
  return singleNumericalParamCommand(_constants.GS, (0, _utils.toPC437)('b'), smoothingMode);
}

/**
 *
 * @param {INVERTED_MODE} invertedMode
 * @return {ArrayBuffer}
 */
function setInvertedMode(invertedMode) {
  return singleNumericalParamCommand(_constants.GS, (0, _utils.toPC437)('B'), invertedMode);
}

/**
 *
 * @param {number} codePage 0-5, 11-21, 26, 30-53, 255
 * @return {ArrayBuffer}
 */
function setCharacterCodePage(codePage) {
  return singleNumericalParamCommand(_constants.ESC, (0, _utils.toPC437)('t'), codePage);
}

/**
 * Reset the code page to the printer default (PC437)
 * @return {ArrayBuffer}
 */
function resetCharacterCodePage() {
  return setCharacterCodePage(0);
}

/**
 *
 * @param {number} fnNumber
 * @param {ArrayBuffer} fnParams
 * @return {ArrayBuffer}
 */
function performGraphicsDataFn(fnNumber) {
  var fnParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ArrayBuffer(0);

  var COMMAND_IDENTIFIER_SIZE = 5;
  var GRAPHICS_FN_HEADER_SIZE = 2;
  var paramSize = fnParams.byteLength;
  var commandPayloadSize = GRAPHICS_FN_HEADER_SIZE + paramSize;

  var commandBytes = new ArrayBuffer(COMMAND_IDENTIFIER_SIZE + GRAPHICS_FN_HEADER_SIZE + paramSize);
  var dv = new DataView(commandBytes);
  dv.setUint8(0, _constants.GS);
  dv.setUint8(1, (0, _utils.toPC437)('('));
  dv.setUint8(2, (0, _utils.toPC437)('L'));
  dv.setUint16(3, commandPayloadSize, true);
  dv.setUint8(5, (0, _utils.toPC437)('0'));
  dv.setUint8(6, fnNumber);
  var i = 7;
  var paramBytes = new Uint8ClampedArray(fnParams);
  paramBytes.forEach(function (byteVal) {
    return dv.setUint8(i++, byteVal);
  });

  return commandBytes;
}

/**
 *
 * @param {String} key ASCII representation of a hexadecimal byte, e.g. '01',
 * 'FF', 'A1', etc.
 * @param {Array<Array<number>>} bitmap only supports images with widths
 * which are divisible by 8
 * @return {string}
 */
function setGraphicsDataMonochrome(key, bitmap) {
  var GRAPHICS_FN_DEFINE_DATA = 83;
  var TONE_MONOCHROME = CHROME_MODE.CHROME_MONO;
  var OTHER_PARAM_BYTES_COUNT = 8;

  var COLOUR_COUNT = 1;
  var COLOUR_1_IDENTIFIER = '1';

  var height = bitmap.length;
  // it is assumed that the bitmap data is a square and is at least 1 row high
  var width = bitmap[0].length;

  var bitmapBytesCount = (1 + width / 8 * height) * COLOUR_COUNT;
  var paramBuffer = new ArrayBuffer(bitmapBytesCount + OTHER_PARAM_BYTES_COUNT);
  var dv = new DataView(paramBuffer);
  var dvUint8 = new Uint8ClampedArray(paramBuffer);

  dvUint8.set([TONE_MONOCHROME, key.charCodeAt(0), key.charCodeAt(1), COLOUR_COUNT]);
  dv.setUint16(4, width, true);
  dv.setUint16(6, height, true);

  var i = 8;
  dvUint8[i++] = (0, _utils.toPC437)(COLOUR_1_IDENTIFIER);
  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x += 8) {
      var bit7 = bitmap[y][x] >= 0.5 ? 1 : 0;
      var bit6 = bitmap[y][x + 1] >= 0.5 ? 1 : 0;
      var bit5 = bitmap[y][x + 2] >= 0.5 ? 1 : 0;
      var bit4 = bitmap[y][x + 3] >= 0.5 ? 1 : 0;
      var bit3 = bitmap[y][x + 4] >= 0.5 ? 1 : 0;
      var bit2 = bitmap[y][x + 5] >= 0.5 ? 1 : 0;
      var bit1 = bitmap[y][x + 6] >= 0.5 ? 1 : 0;
      var bit0 = bitmap[y][x + 7] >= 0.5 ? 1 : 0;

      var byteVal = bit7 << 7 | bit6 << 6 | bit5 << 5 | bit4 << 4 | bit3 << 3 | bit2 << 2 | bit1 << 1 | bit0;
      dvUint8[i++] = byteVal;
    }
  }

  return performGraphicsDataFn(GRAPHICS_FN_DEFINE_DATA, paramBuffer);
}

/**
 *
 * @param {string} key
 * @param {number} xScale
 * @param {number} yScale
 * @return {ArrayBuffer}
 */
function printGraphics(key, xScale, yScale) {
  var GRAPHICS_FN_PRINT = 85;
  var fnParams = new ArrayBuffer(4);
  var dv = new Uint8ClampedArray(fnParams);
  dv.set([key.charCodeAt(0), key.charCodeAt(1), xScale, yScale]);
  return performGraphicsDataFn(GRAPHICS_FN_PRINT, fnParams);
}

/**
 *
 * @param {SOUND_MODE} soundMode pitch, duration and pattern to sound
 * @param {number} repeatCount number of times to repeat the specified sound
 * mode
 * @param {number} cycleTime delay (x100ms) between each repeat
 * @return {ArrayBuffer}
 */
function soundBuzzer(soundMode, repeatCount, cycleTime) {
  var COMMAND_IDENTIFIER_SIZE = 5;
  var BUZZER_FN_BEEP_BUZZER = 48;
  var BUZZER_FN_HEADER_SIZE = 1;
  var BUZZER_FN_PARAM_SIZE = 3;
  var commandPayloadSize = BUZZER_FN_HEADER_SIZE + BUZZER_FN_PARAM_SIZE;

  var commandBytes = new ArrayBuffer(COMMAND_IDENTIFIER_SIZE + BUZZER_FN_HEADER_SIZE + BUZZER_FN_PARAM_SIZE);
  var dv = new DataView(commandBytes);
  dv.setUint8(0, _constants.ESC);
  dv.setUint8(1, (0, _utils.toPC437)('('));
  dv.setUint8(2, (0, _utils.toPC437)('A'));
  dv.setUint16(3, commandPayloadSize, true);
  dv.setUint8(5, BUZZER_FN_BEEP_BUZZER);
  dv.setUint8(6, soundMode);
  dv.setUint8(7, repeatCount);
  dv.setUint8(8, cycleTime);

  return commandBytes;
}